import { assign, memoize } from '@antv/util';
import { blend } from '../../utils/color/blend';
import { log, LEVEL } from '../../utils';
import { venn, scaleSolution } from './layout/layout';
import { intersectionAreaPath, computeTextCentres } from './layout/diagram';
import { ID_FIELD, PATH_FIELD } from './constant';
import { VennData, VennOptions } from './types';

type ColorMapFunction = (
  colorPalette: string[],
  data: VennData,
  blendMode: VennOptions['blendMode'],
  setsField: VennOptions['setsField']
) => Map<string, string>;

/**
 * è·å é¢è²æ å°
 * @usage colorMap.get(id) => color
 *
 * @returns Map<string, string>
 */
export const getColorMap = memoize(
  ((colorPalette, data, blendMode, setsField) => {
    const colorMap = new Map<string /** id */, string /** color */>();
    const colorPaletteLen = colorPalette.length;
    data.forEach((d, idx) => {
      if (d[setsField].length === 1) {
        colorMap.set(d[ID_FIELD], colorPalette[(idx + colorPaletteLen) % colorPaletteLen]);
      } else {
        /** ä¸è¬é½æ¯å¯ä»¥è·åå°é¢è²çï¼å¦æä¸æ­£ç¡® å°±æ¯è¾å¥äºéæ³æ°æ® */
        const colorArr = d[setsField].map((id) => colorMap.get(id));
        colorMap.set(
          d[ID_FIELD],
          colorArr.slice(1).reduce((a, b) => blend(a, b, blendMode), colorArr[0])
        );
      }
    });

    return colorMap;
  }) as ColorMapFunction,
  (...params) => JSON.stringify(params)
) as ColorMapFunction;

/**
 * ç»é¦æ©å¾æ°æ®è¿è¡å¸å±
 *
 * @param data
 * @param width
 * @param height
 * @param padding
 * @returns é¦æ©å¾æ°æ®
 */
export function layoutVennData(options: VennOptions, width: number, height: number, padding: number = 0): VennData {
  const { data, setsField, sizeField } = options;

  // å¤çç©ºæ°æ®çæåµ
  if (data.length === 0) {
    log(LEVEL.WARN, false, 'warn: %s', 'æ°æ®ä¸è½ä¸ºç©º');
    return [];
  }

  const vennData: VennData = data.map((d) => ({
    ...d,
    sets: d[setsField] || [],
    size: d[sizeField],
    [PATH_FIELD]: '',
    [ID_FIELD]: '',
  }));
  // 1. è¿è¡æåºï¼é¿åå¾å½¢åç´ é®æ¡
  vennData.sort((a, b) => a.sets.length - b.sets.length);
  // todo 2. å¯ä»¥å¨è¿éå¤çä¸éæ³æ°æ®è¾å¥ï¼é¿åç´æ¥ crash

  const solution = venn(vennData);
  const circles = scaleSolution(solution, width, height, padding);
  const textCenters = computeTextCentres(circles, vennData);
  vennData.forEach((row) => {
    const sets = row.sets;
    const id = sets.join(',');
    row[ID_FIELD] = id;
    // ä¿ç vennText å¸å±æ¹æ³
    const setCircles = sets.map((set) => circles[set]);
    let path = intersectionAreaPath(setCircles);
    if (!/[zZ]$/.test(path)) {
      path += ' Z';
    }
    row[PATH_FIELD] = path;
    const center = textCenters[id] || { x: 0, y: 0 };
    assign(row, center);
  });
  return vennData;
}

/**
 * æ£æ¥æ¯å¦å­å¨ éæ³åç´ 
 * @param legalArr åæ³éåï¼['A', 'B']
 * @param testArr æ£æ¥éåï¼['A', 'B', 'C'] or ['A', 'C']ï¼å­å¨éæ³ 'C'ï¼
 * @return boolean
 */
export function islegalSets(legalArr: any[], testArr: any[]): boolean {
  for (let i = 0; i < testArr.length; i++) {
    if (!legalArr.includes(testArr[i])) {
      return false;
    }
  }
  return true;
}
